import { Card } from "../../components/card.component";
import { AccountSettings } from "./accountSettings.component";
import { ChangePasswordForm } from "./ChangePasswordForm.component";
import { EmailSettings } from "./emailSettings.component";
import { GenerateInvoice } from "./generateInvoice.component";
import { TaskSettings } from "./taskSettings.component";

export const Settings = ({
  hideAccountSettings,
  hideChangePassword,
  hideTaskSettings,
  hideEmailSettings,
  expandAccountSettings,
  expandChangePassword,
  expandTaskSettings,
  expandEmailSettings,
  hideGenerateInvoice,
}: {
  hideAccountSettings?: boolean;
  hideChangePassword?: boolean;
  hideTaskSettings?: boolean;
  hideEmailSettings?: boolean;
  expandAccountSettings?: boolean;
  expandChangePassword?: boolean;
  expandEmailSettings?: boolean;
  expandTaskSettings?: boolean;
  hideGenerateInvoice?: boolean;
  hideDataExchange?: boolean;
}) => {
  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col content-box-title">
            <div>
              <p className="text-capitalize mb-0 text-green-200">
                Personal Settings
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <div className="accordion" id="accordionExample">
        {!hideAccountSettings && (
          <AccountSettings expanded={expandAccountSettings} />
        )}
        {!hideEmailSettings && <EmailSettings expanded={expandEmailSettings} />}
        {!hideTaskSettings && <TaskSettings expanded={expandTaskSettings} />}
        {!hideChangePassword && (
          <ChangePasswordForm expanded={expandChangePassword} />
        )}
      </div>
      {!hideGenerateInvoice && (
        <div className="d-flex flex-column">
          <GenerateInvoice />
          <small className="text-muted mt-2 text-center">
            Please be careful with this button. Every time you press it, it will
            generate selected month's invoice based on all check-ins that have been
            verified but not invoiced yet.
          </small>
        </div>
      )}
    </Card>
  );
};
